var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1 -1 29.052 26.966",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.974 3.296a6.945 6.945 0 0 0-10.316 0l-.131.128-.12-.128a6.955 6.955 0 0 0-10.314 0 8.112 8.112 0 0 0 0 10.879l8.191 8.818a3.073 3.073 0 0 0 4.492 0l8.191-8.818a8.148 8.148 0 0 0 .007-10.879Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.36471fa4d8da199b2a1a6fad5fb0325f.svg";
export { ForwardRef as ReactComponent };